module.exports = __webpack_public_path__ + "4c25d3829e3bb034efbcf631f7360ad7.pdf";